import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SourcingOils = () => {
  useEffect(() => {
    document.title = "Sourcing of Oils - Deww Botanicals";
  }, []);

  const location = useLocation();
  const currentUrl = location.pathname;

  // Check if the URL contains a specific word
  const shouldShowElement = currentUrl.includes("sourcing");

  return (
    <>
      {/* // Page Header Start */}
      {shouldShowElement && (
        <div className="container-fluid page-header position-relative banner_video overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="position-absolute w-100 h-100 object-fit-cover"
          style={{ top: 0, left: 0, zIndex: -1 }}
        >
          <source src="../assets/sourcing.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
          <div className="container">
            <h1 className="display-5 mb-3 animated slideInDown">
              Sourcing of Oils
            </h1>
            <nav aria-label="breadcrumb animated slideInDown">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <span className="text-body">Home</span>
                </li>
                <li
                  className="breadcrumb-item text-dark active"
                  aria-current="page"
                >
                  Sourcing of Oils
                </li>
              </ol>
            </nav>
          </div>
        </div>
      )}
      {/* // Page Header End */}

      {/* {!shouldShowElement && ( */}
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-12 col-md-9 m-auto p-0 d-flex align-items-center justify-content-start">
            <div className="content-wrap px-3 py-4 p-md-5">
              <h2>
                Sourcing Excellence: Celebrating the Heritage of Indian Oils
              </h2>

              <p>
                At Deww Botanicals, we take great pride in sourcing most of our
                essential and carrier oils directly from India, a country
                renowned for its rich traditions, fertile lands, and historical
                expertise in oil production. India is recognized worldwide as a
                leading provider of high-quality botanical oils, and we are
                dedicated to preserving this legacy by delivering the finest
                Indian oils to the global market.
              </p>
              <h4>A Tradition of Purity and Potency</h4>
              <p>
                Indian oils have gained international recognition for their
                potency, stability, and rich aroma. This esteemed reputation is
                no coincidence; it stems from centuries of agricultural wisdom,
                meticulous cultivation, and advanced distillation techniques
                handed down through generations. The purity and strength of
                these oils make them highly sought after across various
                industries, including personal care, aromatherapy,
                pharmaceuticals, and perfumery.
              </p>
              <h4>Farm-Fresh and Ethically Sourced</h4>
              <p>
                Our oils are sourced directly from local Indian farms and
                distilleries, many of which use sustainable and organic farming
                methods. By eliminating intermediaries and working directly with
                growers, we ensure the following:
              </p>

              <ul>
                <li>Maximum freshness for each batch</li>
                <li>Complete traceability and transparency</li>
                <li>Fair trade practices that support rural livelihoods</li>
              </ul>

              <p>
                This farm-to-bottle approach allows us to maintain the
                integrity, aroma, and therapeutic properties of every oil we
                offer.
              </p>

              <h4>India: A Global Powerhouse in Oil Production</h4>
              <p>
                India is among the largest producers and exporters of essential
                and carrier oils. It has a diverse portfolio of over 100 floral,
                herbal, and spice-based oils that are officially recognized by
                the International Organization for Standardization (ISO). From
                the soothing scent of lavender and the earthy aroma of vetiver
                to exotic spices like cardamom and clove, Indian oils are
                renowned for their authenticity and effectiveness.
              </p>
              <h4>Quality That Speaks for Itself</h4>
              <p>
                Every oil we supply undergoes thorough testing and quality
                checks and is supported by complete documentation, including
                Certificates of Analysis (COAs), Material Safety Data Sheets
                (MSDS), GC-MS reports, and more. This ensures that our products
                meet the highest international standards. Whether you are a
                formulator, retailer, or bulk buyer, you can count on the
                consistency and quality of our products sourced from India.
              </p>

              <p>
                At Deww Botanicals, we believe that sourcing goes beyond simple
                procurement; it involves honoring tradition, supporting ethical
                agriculture, and delivering exceptional quality. We take pride
                in bringing you the essence of India’s rich botanical heritage
                in every drop.
              </p>

              {/* <p className="text-justify">
                At Deww Botanicals, we take pride in sourcing the majority of
                our essential and carrier oils from India, a globally renowned
                hub for high- quality oils. Indian oils are celebrated for their
                remarkable strength, stability, and pure aroma, reflecting the
                rich tradition and expertise in oil production.{" "}
              </p>
              <p>
                Our oils are directly sourced from local farms, ensuring
                freshness and maintaining the integrity of each product. We are
                committed to providing our customers with satisfactory quality
                and purity, embodying our motto to deliver the very best.{" "}
              </p>

              <p>
                India stands as the world’s largest producer and exporter of a
                diverse range of oils, including over 100 floral and spice-based
                varieties recognized by the International Organization for
                Standardization (ISO). Our extensive selection includes these
                premium oils, reflecting the rich agricultural heritage and
                expertise that make Indian oils unparalleled on the global
                stage.
              </p> */}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default SourcingOils;
